import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {


    useEffect(() => {
        window.scrollTo(0, 0)

    }, []);




        return (
            <div>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link> <span className="mx-2 mb-0">/</span> <strong className="text-black">Shipping Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{width : "99% " ,padding : "80px 30px"}}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{fontWeight :"bold"}}>
                                <h1>Shipping Policy</h1>

<h2>Shipment</h2>
<p>
    Our shipping timing for orders delivery varies for different products and categories. It will be mentioned on the product page, informed on order confirmation, and any delays will be communicated accordingly. If no communication is received, it may be due to a lack of contact information (Email / Phone).
</p>
<p>
    Please note that unexpected delivery delays may occur due to customs clearance or other undefined reasons. Delays can extend up to 5-6 working days or more. We are not responsible for any kind of delays, nor for any delays that are not communicated to the customer, whether for domestic or international orders placed using any payment method.
</p>

<h2>Delivery Charges</h2>
<p>
    Delivery charges may vary depending on the type of products ordered and the location you select. These charges are non-refundable. We take no responsibility for any additional charges in terms of customs or duties imposed by local authorities or governments (outside of Pakistan). Any customs charges must be borne by the customer.
</p>

<div class="note">
    <strong>Note:</strong> Please ensure that your contact information is accurate to avoid any communication issues regarding your order.
</div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        )
    
}


export default Contact;